import { Message } from "../pages/ChatWith.page";
import { ChatMessage } from "./api";

export const parseChatMessage = (chatMessage: ChatMessage, userId: string): Message => ({
  id: chatMessage._id,
  isIncoming: chatMessage.sender != userId,
  content: chatMessage.content,
});
